import { Stack } from '@mui/material';
import LinkedImageBanner from '../LinkedImageBanner';
import AuthButtons from './AuthButtons';
import { _ContentTitleWithMarginTop, Body2, H5 } from './styles';

const questionAnswers = [
  {
    question: "身バレはしませんか？",
    answer: "完全匿名で利用できるため身バレの心配はございません。また、女性はマッチするまで男性からプロフィールを見られませんので、安心してご利用いただけます。"
  },
  {
    question: "誰でも利用できますか？",
    answer: "18歳以上であればどなたでもご利用いただけます。"
  },
  {
    question: "男性ですが審査の結果が届きません。",
    answer: "審査結果は通過した方のみにご連絡させていただいております。また、審査提出いただいた方には審査自体は100％実施しておりますのでご安心ください。"
  }
]

const FQAs = () => {
  return (
    <div>
      <_ContentTitleWithMarginTop style={{ marginTop: 80 }}>
        よくあるご質問
      </_ContentTitleWithMarginTop>
      <Stack
        width={1}
        direction="column"
        alignItems="center"
        spacing={3}
      >
        {questionAnswers.map((question, index) => (
          <Stack key={index} direction="column" alignSelf="flex-start" spacing={2} px={4}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <img src="/images/hero-question.png" alt="question" style={{ width: 24, height: 24 }} />
              <H5 variant="body1" fontWeight={700}>{question.question}</H5>
            </Stack>
            <Body2 sx={{ marginTop: '8px !important' }}>
              {question.answer}
            </Body2>
          </Stack>
        ))}

        <img src="/images/hero-end.png" alt="ウラハル" style={{ width: 180, height: 185 }} />
        <AuthButtons customStyles={{ position: "relative", marginTop: 40, marginBottom: 20 }} />
        <img src="/images/uraharu-logo.svg" alt="logo" style={{ width: 190, height: 45, marginTop: 8, marginBottom: 24 }} />
        <LinkedImageBanner customStyles={{
          marginBottom: 20,
          height: "auto",
          minHeight: 45,
          marginTop: -20,
        }} />
      </Stack>
    </div>
  )
}

export default FQAs;
